import { render, staticRenderFns } from "./ModuleNamesDropdownForAdd.vue?vue&type=template&id=526ca4ad&"
import script from "./ModuleNamesDropdownForAdd.vue?vue&type=script&lang=js&"
export * from "./ModuleNamesDropdownForAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports